module.exports = __webpack_public_path__ + "assets/img/more-btn-df065cad.png";